import { render, staticRenderFns } from "./TaktPlanTrainDetailsDialog.view.vue?vue&type=template&id=76bf691a&scoped=true&"
import script from "./TaktPlanTrainDetailsDialog.view.vue?vue&type=script&lang=js&"
export * from "./TaktPlanTrainDetailsDialog.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bf691a",
  null
  
)

export default component.exports